import { FC, memo } from 'react';
import { Table } from 'shared/ui/Table';
import { OrderListItem } from 'entities/order';
import { OrderResponseDto } from 'shared/api';
import { ORDER_TABLE_COLUMNS } from '../../constants/orderConstants';

interface OrderTableProps {
  orders: OrderListItem[];
  onEdit: (order: OrderListItem) => void;
  onDelete: (id: number) => void;
  onComplete: (order: OrderListItem) => void;
  onDownload: (attachmentUuid: string, filename?: string) => void;
}

export const OrderTable: FC<OrderTableProps> = memo(({
  orders,
  onDelete,
  onComplete,
  onDownload,
}) => {
  const actions = [
    {
      key: 'complete',
      label: 'Завершить',
      onClick: (record: OrderListItem) => onComplete(record),
      isActive: (record: OrderListItem) => record.status !== OrderResponseDto.status.COMPLETED,
    },
    {
      key: 'download',
      label: 'Скачать отчет',
      onClick: (record: OrderListItem) => {
        if (record.reportFileUuids && record.reportFileUuids.length > 0) {
          onDownload(record.reportFileUuids[0], `Отчет_${record.orderCode}`);
        }
      },
      isActive: (record: OrderListItem) => record.reportFileUuids && record.reportFileUuids.length > 0,
    },
    // {
    //   key: 'edit',
    //   label: 'Редактировать',
    //   onClick: (record: OrderListItem) => onEdit(record),
    // },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: (record: OrderListItem) => onDelete(record.id!),
      danger: true,
    },
  ];

  return (
    <Table
      columns={ORDER_TABLE_COLUMNS}
      dataSource={orders}
      rowKey="id"
      hasPagination
      actions={actions}
    />
  );
});

OrderTable.displayName = 'OrderTable';
